// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2ulZT","label":"Section_label__DwbF6","contentWrap":"Section_contentWrap__1b75U","footer":"Section_footer__26ypR","footerInner":"Section_footerInner__1Gd2p"};